<template>
  <div>
    <base-nav
      v-model="showMenu"
      class="base-nav-desktop navbar-absolute top-navbar"
      type="white"
      :transparent="true"
    >
      <div slot="brand" class="navbar-wrapper">
        <div class="navbar-minimize d-inline">
          <sidebar-toggle-button />
        </div>
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        >
          <button type="button" class="navbar-toggler" @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
            <span class="navbar-toggler-bar bar4"></span>
          </button>
        </div>
        <a class="navbar-brand" href="#/module">{{ routeName }}</a>
      </div>

      <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
        <div v-if="isLoggedIn" class="form-group mr-2">
          <label class="mt-3"> Conectado como: {{ getUserDisplayName }} </label>
        </div>
        <base-dropdown
          tag="li"
          :menu-on-right="!$rtl.isRTL"
          title-tag="a"
          class="nav-item"
          title-classes="nav-link"
          menu-classes="dropdown-navbar"
        >
          <template slot="title">
            <div class="photo">
              <img src="/img/mike.jpg" />
            </div>
            <b class="caret d-none d-lg-block d-xl-block"></b>
            <p class="d-lg-none">Log Out</p>
          </template>
          <div class="dropdown-divider"></div>
          <li class="nav-link">
            <label class="toggleLabel nav-item dropdown-item">
              Sidebar
              <base-switch
                class="toggleSwitch"
                v-model="sidebarMini"
                @input="minimizeSidebar"
              ></base-switch>
            </label>
          </li>
          <li class="nav-link nav-darkmode">
            <label class="toggleLabel nav-item dropdown-item">
              Dark mode
              <base-switch
                class="toggleSwitch"
                v-model="darkMode"
                @input="toggleMode"
              ></base-switch>
            </label>
          </li>
          <div v-if="isLoggedIn" class="dropdown-divider"></div>
          <li v-if="isLoggedIn" class="nav-link">
            <a @click.prevent="logout" class="nav-item dropdown-item">{{
              $t("checklist.navbar.LogOut")
            }}</a>
          </li>
        </base-dropdown>
      </ul>
    </base-nav>

    <base-nav
      v-model="showMenu"
      class="base-nav-mobile navbar-absolute top-navbar"
      type="white"
      :transparent="true"
    >
      <div slot="brand" class="navbar-wrapper">
        <div class="navbar-minimize d-inline">
          <sidebar-toggle-button />
        </div>
        <div
          class="navbar-toggle d-inline"
          :class="{ toggled: $sidebar.showSidebar }"
        >
          <button type="button" class="navbar-toggler" @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
            <span class="navbar-toggler-bar bar4"></span>
          </button>
        </div>
      </div>

      <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
        <div class="form-group">
          <label>
            <router-link to="/module" class="check">
              <a>{{ $t("geral.modules") }}</a>
            </router-link>
          </label>
        </div>
        <li v-if="isLoggedIn" class="nav-link ml-4 mb-2">
          {{ getUserDisplayName }}
        </li>
        <div class="dropdown-divider"></div>
        <li class="nav-link nav-darkmode">
          <label class="toggleLabel nav-item dropdown-item">
            Dark mode
            <base-switch
              class="toggleSwitch"
              v-model="darkMode"
              @input="toggleMode"
            ></base-switch>
          </label>
        </li>
        <div v-if="isLoggedIn" class="dropdown-divider"></div>
        <li v-if="isLoggedIn" class="nav-link">
          <a
            @click.prevent="logout"
            class="nav-item dropdown-item"
            style="color: black"
            >{{ $t("checklist.navbar.LogOut") }}</a
          >
        </li>
        <!-- </base-dropdown> -->
      </ul>
    </base-nav>
  </div>
</template>

<script>
//import { CollapseTransition } from "vue2-transitions";
import { BaseNav, BaseSwitch, Modal } from "@/components";
import SidebarToggleButton from "@/pages/Layout/SidebarToggleButton";

export default {
  components: {
    SidebarToggleButton,
    //  CollapseTransition,
    BaseNav,
    BaseSwitch,
    Modal,
  },
  computed: {
    getCompanyFantasyName() {
      return this.$store.getters.companyFantasyName;
    },
    getUserDisplayName() {
      return this.$store.getters.userDisplayname;
    },
    routeName() {
      const { name, meta } = this.$route;
      if (meta) if (meta.title) return this.capitalizeFirstLetter(meta.title);
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    },
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  data() {
    return {
      activeNotifications: false,
      darkMode: true,
      showMenu: false,
      sidebarMini: true,
      searchModalVisible: false,
      searchQuery: "",
    };
  },
  created() {
    this.sidebarMini = !this.$sidebar.isMinimized;
  },
  beforeMount() {
    this.darkMode = this.$store.getters.darkmode;
    this.toggleModeStyle(this.darkMode);
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    minimizeSidebar() {
      this.$sidebar.toggleMinimize();
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    toggleMode(type) {
      this.$store.dispatch("darkmode", type);
      this.toggleModeStyle(type);
    },
    toggleModeStyle(type) {
      let docClasses = document.body.classList;
      if (type) {
        docClasses.remove("white-content");
      } else {
        docClasses.add("white-content");
      }
    },
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },
};
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
.toggleLabel {
  min-width: 180px;
}
.toggleSwitch {
  position: absolute;
  right: 20px;
}
@media (max-width: 992px) {
  .base-nav-desktop {
    display: none;
  }
}

@media (min-width: 992px) {
  .base-nav-mobile {
    display: none;
  }
}
</style>
